import React from "react";
import { Link } from "react-router-dom";
import "../../styles/home/DualCTASection.css";

const DualCTASection = () => {
  return (
    <section className="dual-cta-section">
      <div className="container">
        <div className="dual-cta-grid">
          {/* Buy Car Side */}
          <div className="cta-card buy-card">
            <div className="cta-icon">🚘</div>
            <h2>Buy Your Dream Car</h2>
            <ul className="benefits-list">
              <li>
                <span className="check-icon">✓</span>
                <span>10+ Quality Checks</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>5-Day Money Back Guarantee</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Free RC Transfer</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>1-Year Warranty</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Flexible Financing Options</span>
              </li>
            </ul>
            <Link to="/buy-cars" className="cta-button primary-cta">
              Browse Cars
              <span className="arrow">→</span>
            </Link>
          </div>

          {/* Sell Car Side */}
          <div className="cta-card sell-card">
            <div className="cta-icon">💰</div>
            <h2>Sell Your Car Instantly</h2>
            <ul className="benefits-list">
              <li>
                <span className="check-icon">✓</span>
                <span>Best Price Guarantee</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Free Doorstep Inspection</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Instant Payment</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Free RC Transfer Assistance</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Sell in Just 30 Minutes</span>
              </li>
            </ul>
            <Link to="/sell-car" className="cta-button secondary-cta">
              Get Offer Now
              <span className="arrow">→</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DualCTASection;